


























import {Component, Prop, Vue} from 'vue-property-decorator'
import ModalBaseControl from './ModalBaseControl.vue'
import {IModalControlButton} from '@/entities'

@Component({
  components: {
    ModalBaseControl
  }
})
export default class ModalBaseBody extends Vue {
  @Prop() readonly controls!: IModalControlButton[]
  @Prop() readonly subject!: any
}
